import axiosIns from '@/libs/axios'
import { syncWatchers, toWatcherForm } from '@/libs/watchers'
import { definitionId } from '@/libs/definitions'

const ROOT_URL = '/Admin/data/projects'
const WATCHERS_URL = '/Admin/data/project_watchers'
export default {
  namespaced: true,
  state: {
    loading: false,
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      id_licenses: null,
      title: null,
      description: null,
      target_date: null,
      id_project_statuses: definitionId('project', 'open'),
      is_public: 1,
      id_manager_users: [],
      watcher_users: [],
      watcher_teams: [],
      id_departments: null,
      id_teams: null,
      id_users: null,
      completedTaskCount: 0,
      taskCount: 0,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    filterParams: {
      keywords: null,
      status: null,
      id_departments: null,
      id_teams: null,
      created_start: null,
      created_end: null,
      target_start: null,
      target_end: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    filterParams(state) {
      return state.filterParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        id_licenses: null,
        title: null,
        description: null,
        target_date: null,
        id_project_statuses: definitionId('project', 'open'),
        is_public: 1,
        id_manager_users: [],
        watcher_users: [],
        watcher_teams: [],
        id_departments: null,
        id_teams: null,
        id_users: null,
        completedTaskCount: 0,
        taskCount: 0,
      }
    },
  },
  actions: {
    async getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_DATA_ITEM')
      commit('SET_DATA_LIST', [])
      const data = JSON.stringify(params || {})
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    async getDataItem({ commit }, id) {
      if (Number(id)) {
        commit('SET_LOADING', true)
        commit('RESET_DATA_ITEM')
        const data = {
          where: {
            'projects.id': id,
          },
          array: false,
        }
        return axiosIns
          .post(ROOT_URL, data)
          .then(response => {
            // Yetkisiz veya olmayan kayıtta BE boş sonuç döner; form varsayılanları korunur.
            const row = response.data.data
            if (row && row.id) commit('SET_DATA_ITEM', toWatcherForm(row))
            commit('SET_LOADING', false)
            return row && row.id ? row : null
          })
          .catch(error => {
            commit('SET_LOADING', false)
            console.error(error)
          })
      }
      return false
    },
    async saveData({ commit }, postData) {
      commit('SET_LOADING', true)
      try {
        const { data } = await axiosIns.post(`${ROOT_URL}/saveData`, JSON.stringify(postData))
        const result = { ...data }
        // Herkese açıkta gözlemci kayıtları korunur, kutu kapanınca aynı seçimler geri gelir.
        if (data.status && postData.is_public === 0 && Array.isArray(postData.watcher_users)) {
          result.watcherError = !(await syncWatchers(WATCHERS_URL, 'id_projects', data.id, postData))
        }
        commit('SET_DATA_SAVE', result)
        commit('SET_LOADING', false)
        return result
      } catch (error) {
        commit('SET_LOADING', false)
        const httpStatus = error?.response?.status
        if (httpStatus >= 400 && httpStatus < 500 && error.response.data?.status === false) {
          commit('SET_DATA_SAVE', error.response.data)
          return error.response.data
        }
        console.error(error)
        return { status: false }
      }
    },
    removeData({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data.status
        })
        .catch(error => console.error(error))
    },
    completeProject({ commit }, { id, closing_note }) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/complete`, JSON.stringify({ id, closing_note }))
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => {
          commit('SET_LOADING', false)
          if (error?.response?.status === 400 && error.response.data?.status === false) {
            commit('SET_DATA_SAVE', error.response.data)
            return error.response.data
          }
          return Promise.reject(error)
        })
    },
    cancelProject({ commit }, { id, cancel_reason }) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/cancel`, JSON.stringify({ id, cancel_reason }))
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => {
          commit('SET_LOADING', false)
          if (error?.response?.status === 400 && error.response.data?.status === false) {
            commit('SET_DATA_SAVE', error.response.data)
            return error.response.data
          }
          return Promise.reject(error)
        })
    },
  },
}
